import { render, staticRenderFns } from "./nofound.vue?vue&type=template&id=2e82b128&scoped=true"
import script from "./nofound.vue?vue&type=script&lang=js"
export * from "./nofound.vue?vue&type=script&lang=js"
import style0 from "./nofound.vue?vue&type=style&index=0&id=2e82b128&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82b128",
  null
  
)

export default component.exports